import { DataContainer } from '../components/DataContainer';
import { useDispatch, useSelector } from 'react-redux';
import { logOut } from '../store/userSlice';

import avatar from '../res/avatar.jpg';
import { URL_PREFIX } from '../api';
import DriverModal from '../screens/DriverModal';
import { useModals } from '@mattjennings/react-modal-stack';

export function UserBadge({  }) {
    const { openModal } = useModals();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user.data);
    const isAuthenticated = useSelector((state) => state.user.authenticated);

    return (
        <DataContainer actionType={'user/fetchUser'} >
            <div className="row g16">
                <div className="column" style={{ gap: '4px', alignItems: 'flex-end' }}>
                    <div className="row g8">
                        {/* <p style={{ padding: '2px 8px', fontSize: '12px', color: 'white', backgroundColor: '#a88', borderRadius: '4px' }}>{isAuthenticated ? (user["role"].toUpperCase()): "GUEST"}</p> */}
                        <b>{isAuthenticated ? user["firstname"] : "Not logged in"}</b>
                    </div>

                    <div className="row g8">
                        <button onClick={() => dispatch(logOut())} style={{ paddingBlock: 2, fontSize: 12 }}>Logi välja</button>
                        { user.role == "admin" && (
                            <button onClick={() => openModal(DriverModal, { id: user.id, isSelf: true })} style={{ paddingBlock: 2, fontSize: 12 }}>Muuda</button>
                        )}
                    </div>
                </div>

                <img
                    src={URL_PREFIX + "/storage/driver/"+user.id.toLowerCase()+".jpg"}
                    style={{ height: "48px", borderRadius: "24px" }}
                />
            </div>
        </DataContainer>
    );
}